import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { ICustomer } from "redux/reducers/models/customer";

export interface IGetAccommodationReservation {
  id?: number;
  with_customer?: true;
  with_units?: boolean;
  with_folio?: boolean;
  with_notes?: boolean;
  start_date?: string;
  end_date?: string;
}

export interface IPostAccommodationReservation {
  customer_id: number;
  unit_type_id: number;
  arrival_date: string;
  departure_date: string;
  currency: string;
  adults: number;
  children: number;
  quoted_total_amount: number;
  customer?: ICustomer;
  payment_method_id: number;
  nightly_rates: number[];
  cart_token?: string;
}

export interface IPostAccommodationCart {
  customer_id: number;
  nightly_rates: number[];
}

interface IPutAccommodationReservation {
  id: number;
  title?: string;
  unit_category_id?: number;
  base_occupancy?: number;
  max_occupancy?: number;
  status?: string;
}

// GET Accommodation Reservations
export async function GetAccommodationReservations(params: IGetAccommodationReservation, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/reservation"), params, useGlobalLoader);
}

// POST Accommodation Reservations
export async function PostAccommodationReservation(params: IPostAccommodationReservation, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/reservation"), params, useGlobalLoader);
}

export async function PostAccommodationCart(params: IPostAccommodationCart, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/reservation/cart"), params, useGlobalLoader);
}
// PUT Accommodation Reservations
export async function PutAccommodationReservation(params: IPutAccommodationReservation, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/reservation"), params, useGlobalLoader);
}

interface IPostAccommodationReservationNote {
  id: number;
  note: string;
}

//POST Accommodation Reservation Note
export async function PostAccommodationReservationNote(
  params: IPostAccommodationReservationNote,
  useGlobalLoader: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/reservation/note"), params, useGlobalLoader);
}
//PUT Accommodation Reservation Note
export async function PutAccommodationReservationNote(
  params: { id: number; note_id: number; note: string },
  useGlobalLoader: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/reservation/note"), params, useGlobalLoader);
}
//DELETE Accommodation Reservation Note
export async function DeleteAccommodationReservationNote(
  params: { id: number; note_id: number },
  useGlobalLoader: boolean,
) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/accommodation/reservation/note"), params, useGlobalLoader);
}
